import React from 'react';

const EditProfile = () => {
    return (
        <div>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti facere nemo vel labore exercitationem eum illum aperiam quidem nam itaque.</p>
        </div>
    );
};

export default EditProfile;